// extracted by mini-css-extract-plugin
export var animationContainer = "_ce-0";
export var asteriskIcon = "_ce-8";
export var conversationLeftSection = "_ce-4";
export var conversationListItem = "_ce-3";
export var conversationMiddleSection = "_ce-5";
export var conversationRightSection = "_ce-6";
export var detailsContent = "_ce-1";
export var listContainer = "_ce-7";
export var modalContent = "_ce-2";